import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseCommonProgress.module.scss'

import BlindContent from '@Components/atoms/BlindContent'
import GifMyhouseAuthProgressLoading from '@Ui/images/myhouse/myhouse_auth_progress--loading.gif'

const cx = className.bind(style)

type Props = {
  title?: string
  subtitle?: string
  isViewportHeight?: boolean
  className?: string
}
const MyhouseCommonProgress: React.FC<Props> = ({ title, subtitle, isViewportHeight, className }: Props) => {
  return (
    <section id="content" className={cx('article', className)} role="main" style={{ minHeight: isViewportHeight ? '100vh' : '' }}>
      <BlindContent />
      <img src={GifMyhouseAuthProgressLoading} alt="로딩 중" className={cx('loading')} />
      {Boolean(title) && <strong className={cx('text')}>{title}</strong>}
      {Boolean(subtitle) && <span className={cx('subtitle')}>{subtitle}</span>}
    </section>
  )
}

export default MyhouseCommonProgress
